export default __webpack_public_path__ + "static/media/Menu.202608fa.svg";